import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import { CURRENCY } from '../../environments/environment';
import {STATUS_INPROGRESS,COMPLETE_STATUS,STATUS_DELETED,STATUS_ACCEPTED_ICON,STATUS_DECLINED_ICON
  ,STATUS_CANCELLED,ACTIVE_STATUS,STATUS_ACTIVE,SUSPEND_STATUS,STATUS_SUSPENDED,STATUS_COMPLETE,STATUS_DEMO_COMP,CANCEL_STATUS,BATCH_STATUS_DELETE,BATCH_STATUS_DELETED
,RATE_TYPE_FIXED,RATE_TYPE_PER_MONTH,RATE_TYPE_FREE,RATE_TYPE_PER_CLASS,RATE_TYPE_PER_HOUR,JOINING_DETAILS} from 'src/app/constants';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-enquiry-details',
  templateUrl: './enquiry-details.component.html',
  styleUrls: ['./enquiry-details.component.scss']
})
export class EnquiryDetailsComponent implements OnInit {
  packageID:string;
  enquiryID:string;
  partyID:string;
  vendorID:string;
  statusId:string;   
  reqDetail:string;
  className:string;
  description:string;  
  currency:string;
  partyNotes:[];
  courseSchedule:any;  
  packageDetails:any;
  vendorDetails:any;
  price:number;
  priceRateTypeId:string;
  enquiryDetails:any;
  joiningDetails:string;
  joiningurl:string; 
  userID:string;
  showToCustomer:string;
  closeResult:string;
  active:string;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService:HelperService,
    private modalService: NgbModal
    ) { }

  ngOnInit() {

    this.enquiryID = this.activatedRoute.snapshot.paramMap.get("enquiryID");      
    this.partyID = this.activatedRoute.snapshot.paramMap.get("partyID"); 
    this.vendorID = this.activatedRoute.snapshot.paramMap.get("vendorID");  

    this.userID = this.helperService.studented_atob(this.helperService.getUserID());
    if(this.userID==""){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`enquiry-details/`+ this.enquiryID + `/` + this.partyID + `/` + this.vendorID);
    }

    this.joiningDetails = JOINING_DETAILS;
    this.currency = CURRENCY;  



   
    
    let enquiryData = {

      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      enquiryID: this.enquiryID,
      partyID: this.partyID,
      vendorID: this.vendorID
    }

    this.apiService.hostEnquiryDetails(enquiryData).subscribe((res:any)=>{        
      
      
      this.packageID = res.data.enquiryDetailsData.data.packageDetails[0].id;     
      
      this.enquiryDetails = res.data.enquiryDetailsData.data.enqueryDetail[0];
      this.vendorDetails = res.data.enquiryDetailsData.data.vendorDetails[0];   
      
      this.reqDetail = res.data.enquiryDetailsData.data.reqDetail[0].reqDetails;      
      this.showToCustomer = res.data.enquiryDetailsData.data.enqueryDetail[0].showToCustomer;  

      this.partyNotes = res.data.enquiryDetailsData.data.partyNotes;
      this.courseSchedule = res.data.enquiryDetailsData.data.courseSchedule[0];
      this.packageDetails = res.data.enquiryDetailsData.data.packageDetails[0];
     

      let packageData = {
        //token: this.helperService.studented_atob(this.helperService.getToken()),
        userID: this.helperService.studented_atob(this.helperService.getUserID()),
        hostID: this.helperService.studented_atob(this.helperService.getHostID()),
        enquiryID:this.enquiryID,
        partyID:this.partyID,
        vendorID: this.vendorID,
        pkgID: this.packageID
      }
  
  
      this.apiService.packageDetails(packageData).subscribe((res:any)=>{  
      
      this.className =  res.data.vendorPkg.data.courseDetails[0].packageName; 
     
      this.description = res.data.vendorPkg.data.courseDetails[0].description; 
      this.price = res.data.vendorPkg.data.courseDetails[0].highPrice;
      this.priceRateTypeId = res.data.vendorPkg.data.courseDetails[0].priceRateTypeId;
  
  
      },async err => {
        
      })
  

    },async err => {
        
    })

    

    
  }

  getEqNumber() {
    if (!this.enquiryID) {
      return "";
    }
    return "SC-EQ-" + this.enquiryID.padStart(8, "0");
  }

  

  getstatus(data) {

    switch (data) {
      case 2: return STATUS_INPROGRESS;
      case 3: return COMPLETE_STATUS;
      case 4: return STATUS_DELETED;
      case 5: return STATUS_ACCEPTED_ICON;
      case 6: return STATUS_DECLINED_ICON;     
      case 7: return STATUS_DEMO_COMP;
      case 8: return STATUS_CANCELLED;
    }
  }

  getBatchStatus(status) {
    if (status === ACTIVE_STATUS) {
      return STATUS_ACTIVE;
    } else if (status === SUSPEND_STATUS) {
      return STATUS_SUSPENDED;
    } else if (status === STATUS_COMPLETE) {
      return COMPLETE_STATUS;
    } else if (status === CANCEL_STATUS) {
      return STATUS_CANCELLED;
    } else if (status === BATCH_STATUS_DELETE) {
      return BATCH_STATUS_DELETED;
    }
  }
  getRateText(priceRateTypeId) {
    if (!priceRateTypeId) {
      return "";
    }

    if (priceRateTypeId === 1) {
      return RATE_TYPE_FIXED;
    } else if (priceRateTypeId === 2) {
      return RATE_TYPE_PER_MONTH;
    }
    else if (priceRateTypeId === 3) {
      return RATE_TYPE_FREE;
    }
    else if (priceRateTypeId === 4) {
      return RATE_TYPE_PER_CLASS;
    }
    else
      return RATE_TYPE_PER_HOUR;
  }

  demoComplete(){
    if(confirm("Do you really want to complete demo?")) {      

    let demoData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      enquiryID:this.enquiryID,
      vendorID:this.vendorID,      
      statusID:"7"
    }

    this.apiService.updateEnquiryStatus(demoData).subscribe((res:any)=>{        
      location.reload();
      alert("Demo is completed");
    })
  }
  }
  Cancel(){
    if(confirm("Do you really want to cancel this Enquiry?")) {     
    let demoData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      enquiryID:this.enquiryID,
      vendorID:this.vendorID,      
      statusID:"8"
    }

    this.apiService.updateEnquiryStatus(demoData).subscribe((res:any)=>{            
      
      alert("Enquiry cancelled");
      location.reload();
    })

  }
}
acceptPack(){

  if(confirm("Do you really want to accept this Demo Class?")) {      

    let demoData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      enquiryID:this.enquiryID,
      vendorID:this.vendorID,      
      statusID:"5"
    }

    this.apiService.updateEnquiryStatus(demoData).subscribe((res:any)=>{  
            
      alert("Class accepted");
      location.reload();    
    })
  }

}

rejectPack(){

  if(confirm("Do you really want to decline this Demo Class?")) {      

    let demoData = {
     // token: this.helperService.getToken(),
      userID: this.helperService.getUserID(),
      hostID: this.helperService.getHostID() ,
      enquiryID:this.enquiryID,
      vendorID:this.vendorID,      
      statusID:"6"
    }

    this.apiService.updateEnquiryStatus(demoData).subscribe((res:any)=>{       
    
      alert("Class declined");
      location.reload();    
    })
  }

}

open(content) {
  this.modalService.open(content, {centered: true}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}


  assessment(){
    this.router.navigateByUrl(`assessment`);
  }
  dashboard(){    
    this.router.navigateByUrl(`dashboard`);
  }
  assignment(){
    this.router.navigateByUrl(`assignment`);
  }
  notice(){
    this.router.navigateByUrl(`notice`); 
  }
  enquiry(){
    this.router.navigateByUrl(`enquiry`);
  }
  content(){
    this.router.navigateByUrl(`content`);
  }
  userProfile(){
    this.router.navigateByUrl(`userprofile`);
  }
  classes(){
    this.router.navigateByUrl(`courses`);
  }
  calender(){
    this.router.navigateByUrl(`calender`);
  }

}
